export default __webpack_public_path__ + "static/media/4.a1c7cd7c.png";